import React from "react";
import Iaa1 from "../../images/IMA/cow.svg";
import Iaa2 from "../../images/IMA/goat.svg";
import Iaa3 from "../../images/IMA/storage-unit.svg";



import { Row, Col } from "react-bootstrap";
import "./IAABlock.css";
import { Button } from "@material-ui/core";

export default function DairyBlock({producers}) {
  const Image = [
    { img: Iaa3, href:"#StorageMachinery"  },
    { img: Iaa1  },
    { img: Iaa2 },
    // { img: Iaa1, href: "/#FillingMachinery"   },

  ];
  return (
    <>
    {
      !producers ?  <div className="Iaa-container Ima-container mb-5">
      <h2 className="text-center mb-0"></h2>

      <Row className="justify-content-center">
        {Image.map((e) => {
          return (
            <Col md={3} className="md-md-0 mb-3">
              <a href={e.href}>
                <div
                  className={`${
                    e.href
                      ? "imageHover Iaa-Cards  Iaa-Cards--mod d-flex justify-content-center align-items-center"
                      : "Iaa-Cards Iaa-Cards--mod d-flex justify-content-center align-items-center card-deactivated"
                  }`}
                >
                  {" "}
                  <img
                    className={`${e.href && "imgCursor filteredimg"}`}
                    src={e.img}
                    alt="icon"
                  />
                </div>
              </a>
            </Col>
          );
        })}
      </Row>
    </div>: 
     <div className="Iaa-container Ima-container mb-5">
     <h2 className="text-center mb-0"></h2>

     <Row className="justify-content-center">
       {Image.map((e) => {
         return (
           <Col md={4} className="md-md-0 mb-3">
             
               <div
                 className= " Iaa-Cards  Iaa-Cards--mod d-flex justify-content-center align-items-center"
               >
                 {" "}
                 <img
                   className={`${e.href && "imgCursor filteredimg"}`}
                   src={e.img}
                   alt="icon"
                 />
               </div>
           </Col>
         );
       })}
     </Row>
     <Button variant="contained" color="primary">
          <a href="http://cbn.gbrapp.com/" target="_blank">Join </a>
        </Button>
   </div>
    }</>
   
  );
}
